import { createContext, useContext, useState, useEffect } from "react";
import { v4 as uuidv4 } from 'uuid';
import ApiConfig from "../apiConfig/ApiConfig";
import { apiRequestHandler } from "../apiConfig/service";

const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cartItems, setCartItems] = useState([]);
  const [user, setUser] = useState(null);
  const [loadingUser, setLoadingUser] = useState(true);

  // 🛒 Add item to cart with additional details
  const addToCart = (item) => {
    const isExisting = cartItems.some(
      (cartItem) =>
        cartItem.name === item.name &&
        cartItem.category === item.category &&
        cartItem.price === item.price
    );

    if (isExisting) return false;

    setCartItems((prevItems) => [
      ...prevItems,
      {
        ...item,
        id: uuidv4(),
        quantity: 1,
        features: item.features || [], // Include features array
        addedAt: new Date().toISOString(), // Optional: Timestamp for when item was added
      },
    ]);
    console.log(cartItems)
    return true;
  };

  // 🗑 Remove item from cart
  const removeFromCart = (id) => {
    setCartItems((prevItems) => prevItems.filter((item) => item.id !== id));
  };

  // 👤 Fetch user
  const fetchUserProfile = async () => {
    const token = localStorage.getItem("token");
    if (!token) {
      setUser(null);
      setLoadingUser(false);
      return;
    }

    try {
      const res = await apiRequestHandler({
        method: "GET",
        endPoint: ApiConfig.getProfile,
        headers: { Authorization: `Bearer ${token}` },
      });

      if (res?.success) {
        setUser(res.data);
      } else {
        setUser(null);
      }
    } catch (error) {
      console.error("User profile fetch error:", error);
      setUser(null);
    } finally {
      setLoadingUser(false);
    }
  };

  // 🔁 Load user on first mount
  useEffect(() => {
    fetchUserProfile();
  }, []);

  return (
    <CartContext.Provider
      value={{
        cartItems,
        addToCart,
        removeFromCart,
        user,
        loadingUser,
        refreshUser: fetchUserProfile,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);